// @ts-strict-ignore
import Space from 'antd/lib/space';
import * as React from 'react';
import StaticBranchIcon from '../icons/StaticBranchIcon';
import MergeBranchesIcon from '../icons/MergeBranchesIcon';
import BranchIcon from '../icons/BranchIcon';
import Text from 'antd/lib/typography/Text';
import Button from 'antd/lib/button';
import { InfoCircleOutlined, LinkOutlined } from '@ant-design/icons';
import { runwayColors } from '../styles/globalStyles';
import Tooltip from 'antd/lib/tooltip';

export interface BranchingDiagramProps {
    usesStaticReleaseBranch: boolean;
    hasPerformedAnyCodePromotion: boolean;
    releaseBranchExists: boolean;
    base: string;
    releaseBranch: string;
    releaseBranchUrl?: string;
    isHotfix: boolean;
}

const BranchingDiagram: React.FC<BranchingDiagramProps> = (props: BranchingDiagramProps) => {
    const isBaseBranchKnown = props.base && props.base != '';
    const baseBranchName = isBaseBranchKnown ? props.base : 'Unknown';
    const isReleaseBranchKnown = props.releaseBranch != '';
    const releaseBranchName = isReleaseBranchKnown ? props.releaseBranch : 'Unknown';
    const baseIsEmptyOrSameAsReleaseBranch = props.releaseBranch === props.base || !props.base;
    return (
        <Space>
            {props.usesStaticReleaseBranch ?
                baseIsEmptyOrSameAsReleaseBranch ?
                    <StaticBranchIcon />
                :   <MergeBranchesIcon isDotted={!props.hasPerformedAnyCodePromotion} />
            :   <BranchIcon isDotted={!props.releaseBranchExists} />}
            <Space direction="vertical">
                <Space size={4}>
                    <Text
                        code={isReleaseBranchKnown}
                        style={{
                            color: isReleaseBranchKnown ? null : runwayColors.statusYellow,
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {releaseBranchName}
                    </Text>
                    {props.releaseBranchUrl && (
                        <Button type="link" icon={<LinkOutlined />} href={props.releaseBranchUrl} target="_blank" />
                    )}
                </Space>
                {props.base && !baseIsEmptyOrSameAsReleaseBranch && (
                    <Space>
                        <Text
                            code={isBaseBranchKnown}
                            style={{
                                color: isBaseBranchKnown ? null : runwayColors.statusYellow,
                                whiteSpace: 'nowrap',
                                opacity:
                                    (
                                        (props.usesStaticReleaseBranch && props.hasPerformedAnyCodePromotion) ||
                                        (!props.usesStaticReleaseBranch && props.releaseBranchExists)
                                    ) ?
                                        0.5
                                    :   1,
                            }}
                        >
                            {baseBranchName}
                        </Text>
                    </Space>
                )}
                {(!props.base || baseIsEmptyOrSameAsReleaseBranch) &&
                    !props.usesStaticReleaseBranch &&
                    props.isHotfix && (
                        <Space>
                            <Text
                                style={{
                                    whiteSpace: 'nowrap',
                                    color: runwayColors.statusGrey,
                                }}
                            >
                                Unknown base
                            </Text>
                            <Tooltip title="The base for this hotfix is unknown because it was created outside of Runway.">
                                <InfoCircleOutlined style={{ color: runwayColors.info }} />
                            </Tooltip>
                        </Space>
                    )}
            </Space>
        </Space>
    );
};

export default BranchingDiagram;
